import { Auth0Provider } from "@auth0/auth0-react";
import { ChakraProvider } from "@chakra-ui/react";
import { AnalyticsBrowser } from "@segment/analytics-next";
import { IntlProvider } from "react-intl";

import { useLocalizedMessages } from "app/hooks/useLocalizedMessages";
import { AppEffectsProvider } from "app/providers/AppEffectsProvider";
import { CustomApolloProvider } from "app/providers/CustomApolloProvider";
import { EppoFeatureFlagsProvider } from "app/providers/CustomEppoProvider";
import { useAppLanguageStore } from "app/stores/useAppLanguageStore";
import { config } from "config";
import { theme } from "theme";

import { AppRouter } from "./AppRouter";

import "fonts/fonts.css";
import "global.css";

import "../../utils/datadog";

export const analytics = AnalyticsBrowser.load({
  writeKey: config.environment.SEGMENT_WRITE_KEY,
});

function App() {
  const messages = useLocalizedMessages();
  const appLanguage = useAppLanguageStore((state) => state.appLanguage);

  return (
    <Auth0Provider
      domain={config.environment.AUTH0_DOMAIN}
      clientId={config.environment.AUTH0_CLIENT_ID}
      authorizationParams={{
        audience: config.environment.AUTH0_AUDIENCE,
        redirect_uri: window.location.origin,
      }}
      useRefreshTokens
      useRefreshTokensFallback
      authorizeTimeoutInSeconds={10}
      cacheLocation="localstorage"
    >
      <ChakraProvider theme={theme}>
        <EppoFeatureFlagsProvider>
          <CustomApolloProvider>
            {/* @ts-ignore */}
            <IntlProvider locale={appLanguage} messages={messages}>
              <AppEffectsProvider>
                <AppRouter />
              </AppEffectsProvider>
            </IntlProvider>
          </CustomApolloProvider>
        </EppoFeatureFlagsProvider>
      </ChakraProvider>
    </Auth0Provider>
  );
}

export default App;
